import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.editTermOrMethod.presenters.editableTermOrMethodTextFieldPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: '{name} updated successfully',
  },
  errorFallback: {
    id: `${scope}.errorFallback`,
    defaultMessage: 'Error processing the request.',
  },
})
